__webpack_require__.p = "https://ordering-latte-cdn.foodtecsolutions.com/cwo-1.0.99/";